import { H1, H2, Text } from '../ui/typography';
import PageSeo from '../seo/PageSeo';

function Contact() {
  return (
    <>
      <PageSeo
        title="Kontakt | Celovška cesta 73, Ljubljana"
        description="Naročite se na uvodno srečanje. Špela Verbnik, psihoterapevtka v Ljubljani. Celovška cesta 73, 041 590 888."
        path="/contact"
      />
    <div className='bg-primaryBg pl-4 pr-4'>
      <div className="lg:w-1/2 m-auto flex flex-col text-center items-center align-middle pt-12 pb-12">
      <H1 style={{color: "#616287"}}>Kontakt</H1>
      <H2 className="text-center">naročite se na uvodno srečanje</H2>
        <Text className="text-base text-center pb-6 pt-12">Uvodno srečanje je namenjeno spoznavanju. Klientu ponuja varen prostor, da spregovori o svojih izzivih, vprašanjih in pričakovanjih. Na srečanju predstavim svoj način dela in terapevtski okvir. Skupaj bova preverila, ali je moj način dela za vas primeren.
</Text>

        <Text className="text-base text-center pb-6 pt-2">Dosegljiva sem preko e-naslova <label className='font-bold'>spela.verbnik@gmail.com</label> ali na telefonski številki <label className='font-bold'>041 590 888</label>.</Text>

        <Text className="text-base text-center pb-6 pt-2">V kolikor se na vaš klic ne bom mogla takoj odzvati, vas ob prvi priložnosti pokličem nazaj.</Text>
        <Text className="text-base text-center pt-2">Vabljeni.</Text>

        <div className='flex justify-center align-middle pt-12 pb-12 w-full'>
          <img className='w-1/3 md:w-[13%]' src="/assets/logo_filler_sage.svg" alt="" />
        </div>

        <div className='flex flex-row items-center w-full'>
          <div className='flex flex-1 flex-col justify-center'>
            <Text className="text-base font-bold text-center pb-6 w-auto">Naslov</Text>
            <Text className="text-base text-center w-auto">Celovška cesta 73</Text>
            <Text className="text-base text-center w-auto">1000 Ljubljana</Text>
          </div>
          
          <div className='flex flex-1 flex-col justify-center'>
            <Text className="text-base text-center font-bold pb-6 w-auto">Telefonska številka</Text>
            <Text className="text-base text-center w-auto">041 590 888</Text>
            <Text className="text-base text-center w-auto">&nbsp;</Text>
          </div>

          <div className='flex flex-1 flex-col justify-center'>
            <Text className="text-base text-center font-bold pb-6 w-auto">Elektronski naslov</Text>
            <Text className="text-base text-center w-auto">spela.verbnik@gmail.com</Text>
            <Text className="text-base text-center w-auto">&nbsp;</Text>
          </div>
        </div>

        <div className="w-full pt-12">
          <iframe
            title="Zemljevid: Celovška cesta 73, Ljubljana"
            src="https://maps.google.com/maps?q=Celov%C5%A1ka%20cesta%2073%2C%201000%20Ljubljana&z=16&output=embed"
            className="w-full h-72 border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        
      </div>
    </div>
    
    </>
    
  );
}

export default Contact; 